export const photomontage = {
  type: "FeatureCollection",
  name: "Data",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [141.20363147400008, -33.910027133999961],
      },
      properties: {
        id: "2",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [141.2279285190001, -33.93432417899993],
      },
      properties: {
        id: "3",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [141.39703595300011, -33.902252079999982],
      },
      properties: {
        id: "5",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [141.79064808400005, -33.852686107999943],
      },
      properties: {
        id: "7",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [142.26201076000007, -34.265735874999962],
      },
      properties: {
        id: "10",
      },
    },
  ],
};

export const existingViewpoint = {
  type: "FeatureCollection",
  name: "Data",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [141.18710948300009, -33.901280197999938],
      },
      properties: {
        id: "1",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [141.28138201800004, -34.048034349999966],
      },
      properties: {
        id: "4",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [141.71386942200002, -33.846854816999951],
      },
      properties: {
        id: "6",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [142.02001219100009, -33.867264334999959],
      },
      properties: {
        id: "8",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [142.26103887800002, -34.101487849999955],
      },
      properties: {
        id: "9",
      },
    },
  ],
};
